module.exports = __webpack_public_path__ + "static/media/Classics_description.f7e924b5.png";